import { render, staticRenderFns } from "./demographicSegmentRow.vue?vue&type=template&id=32f4f4b2&scoped=true&lang=html&"
import script from "./demographicSegmentRow.vue?vue&type=script&lang=js&"
export * from "./demographicSegmentRow.vue?vue&type=script&lang=js&"
import style0 from "./demographicSegmentRow.vue?vue&type=style&index=0&id=32f4f4b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f4f4b2",
  null
  
)

export default component.exports